import logo from "./logo.svg";
import "./App.css";
import Problems from "./problems";
import ProblemLists from "./problem-list";

function App() {
  return (
    <div className="App">
      <ProblemLists />
    </div>
  );
}

export default App;
